import type { ProgressRingProps } from "../types/layout.js";

export function ProgressRing({ value, label, caption }: ProgressRingProps) {
  const bounded = value === null ? null : Math.min(100, Math.max(0, value));
  return (
    <div
      aria-label={label}
      aria-valuemax={bounded === null ? undefined : 100}
      aria-valuemin={bounded === null ? undefined : 0}
      aria-valuenow={bounded ?? undefined}
      className="relative mx-auto my-6 size-48 xl:size-52"
      role={bounded === null ? "img" : "progressbar"}
    >
      <svg aria-hidden="true" className="size-full -rotate-90" viewBox="0 0 120 120">
        <circle
          className="text-muted/40"
          cx="60"
          cy="60"
          fill="none"
          r="51"
          stroke="currentColor"
          strokeWidth="11"
        />
        <circle
          className="text-primary"
          cx="60"
          cy="60"
          fill="none"
          pathLength="100"
          r="51"
          stroke="currentColor"
          strokeDasharray={`${bounded ?? 0} 100`}
          strokeLinecap={bounded ? "round" : "butt"}
          strokeWidth="11"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center px-7 text-center">
        <span className="text-4xl font-medium tracking-tight tabular-nums">
          {bounded === null ? "—" : `${Math.round(bounded)}%`}
        </span>
        {caption ? <span className="mt-2 text-sm text-muted-foreground">{caption}</span> : null}
      </div>
    </div>
  );
}
